import SelectFieldInterface from '@/shared/models/select-field-interface';
import { RuleDomain } from './rule-types';

export const defaultDomains: RuleDomain[] = [
  { value: 'MOVEMENT', label: 'Movimentação' },
  { value: 'STATEMENT', label: 'Extrato' },
];

export const movementDomainFields: SelectFieldInterface<string>[] = [
  { value: 'record_holderName', label: 'record_holderName' },
  { value: 'record_documentNumber', label: 'record_documentNumber' },
  { value: 'record_movementType', label: 'record_movementType' },
  { value: 'record_validityDate', label: 'record_validityDate' },
  { value: 'record_contractId', label: 'record_contractId' },
  { value: 'record_subContractId', label: 'record_subContractId' },
  { value: 'record_benefitType', label: 'record_benefitType' },
];

export const statementDomainFields: SelectFieldInterface<string>[] = [
  { value: 'contract_planCode', label: 'contract_planCode' },
  { value: 'contract_contractId', label: 'contract_contractId' },
  { value: 'contract_subContractId', label: 'contract_subContractId' },
  { value: 'beneficiary_cardNumber', label: 'beneficiary_cardNumber' },
  { value: 'beneficiary_cpf', label: 'beneficiary_cpf' },
  { value: 'beneficiary_name', label: 'beneficiary_name' },
  { value: 'beneficiary_birthDate', label: 'beneficiary_birthDate' },
  { value: 'event_eventType', label: 'event_eventType' },
  { value: 'event_eventDate', label: 'event_eventDate' },
  { value: 'copay_totalAmount', label: 'copay_totalAmount' },
  { value: 'copay_copayPercentage', label: 'copay_copayPercentage' },
  { value: 'copay_procedureCode', label: 'copay_procedureCode' },
  { value: 'copay_copayValue', label: 'copay_copayValue' },
];

export const domainFieldsMap: Record<string, SelectFieldInterface<string>[]> = {
  MOVEMENT: movementDomainFields,
  STATEMENT: statementDomainFields,
};
